<template>
    <section id="comicbook" class="bg-primary">
        <div class="container"  >
            <h2 class="my-3 text-capitalize font-weight-bold title">ComicBook</h2>
            <div class="weekly  mb-3 ">
                <ul class="list-inline text-center">
                    <li class="col-md-2 list-inline-item "   v-bind:class="{ active : activeDay == 1 }"   @click="weeklyCommic(1)">월</li>
                    <li class="col-md-2 list-inline-item"  v-bind:class="{ active : activeDay == 2 }" @click="weeklyCommic(2)">화</li>
                    <li class="col-md-2 list-inline-item"  v-bind:class="{ active : activeDay == 3 }" @click="weeklyCommic(3)">수</li>
                    <li class="col-md-2 list-inline-item"  v-bind:class="{ active : activeDay == 4 }" @click="weeklyCommic(4)">목</li>
                    <li class="col-md-2 list-inline-item"  v-bind:class="{ active : activeDay == 5 }" @click="weeklyCommic(5)">금</li>
                </ul>
            </div>
            <div>
                <ul class="list-inline event-list">
                    <li class="col-sm-3 mb-3 list-inline-item"  v-for="(item, index) in items" :key="index" >
                        <a href="">
                            <img :src="item.image" :alt="item.name" class="img-fluid">
                            <div class="cont small bg-light">
                                <p class="font-weight-bold">{{item.name}}</p>
                                <p class="font-weight-bold">{{item.desc}}</p>
                                <span >NC COMIX | 만물상</span>
                            </div>
                        </a>
                    </li>
                </ul>
                
            </div>
        </div>
    </section>
</template>
<script>

export default {
        
     data () {
        return {
        activeDay: 1,
        items:[],
        items0:[{image: 'https://buffimgs.plaync.com/buff/contents/0/745052/list_9573f2d76ac9b98e9d61aa1a025b8ae02db4b377e9af111e41c4741cb48f4e5d.jpg' , name: '기묘한 기담1', desc: '재밌다 '}],
        items1: [{image: 'https://buffimgs.plaync.com/buff/contents/0/10077/list_620a770482b05ee8997aca76c7b4273790546506333be327a0954a3e2e19c149.jpg' , name: '기묘한 기담2', desc: '재밌다 '}],
        items2: [{image: 'https://buffimgs.plaync.com/buff/contents/0/745052/list_9573f2d76ac9b98e9d61aa1a025b8ae02db4b377e9af111e41c4741cb48f4e5d.jpg' , name: '기묘한 기담3', desc: '재밌다 '}],
        items3: [{image: 'https://buffimgs.plaync.com/buff/contents/0/1000972/list_5451ad488b09eeaac3b409d901e4699214f667216b765b8ea85a35054bafd3b5.jpg' , name: '기묘한 기담3', desc: '재밌다 '}]

        }
  },
  created : function () {
    this.items =this.items0;
  },
    methods: {
        weeklyCommic: function(week) {
        
            this.activeDay = week;
            this.items =this.items0;
            if(week == 2){
                this.items =this.items1;
            }else if(week == 3){
                this.items =this.items2;
            }else if(week == 4){
                this.items =this.items3;
            }


        }
    }
}
</script>
<style>
.weekly { border-bottom: 1px solid #d0eaed; }
.weekly  li { padding:5px 0;}
.weekly  li.active {
    background: #0ec2d7;
    border: 1px solid rgba(0,0,0,.25);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Comicbook.vue